import { createApp } from 'vue'
import store from '@storePath'
import CheckoutApp from '@componentPath/checkout/CheckoutApp'

createApp({})
    .component('checkout-app', CheckoutApp)
    .use(store)
    .mount('#checkout_wrapper');